import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Error from './pages/error/error';
import Status from './pages/status';
import Acceptance from './pages/acceptance/acceptance';
import AcceptanceKO from './pages/acceptance/acceptance_ko';
import AgeGate from './pages/acceptance/ageGate';
import Terms from './pages/terms/terms';
import Loading from './pages/loading/loading';
import Login from './pages/login/login';
import CodeOfConduct from './pages/codeOfConduct/codeOfConduct';
import StatusTest from './pages/status-test';
import Video from './pages/video/video';
import Cdni from './pages/cdni/cdni';
import Splash from './pages/splash/splash';
import Upsell from './pages/upsell/upsell';
import PostLogin from './pages/postLogin/postLogin';
import Gated from './pages/gated/gated';
import { createHashRouter, RouterProvider } from 'react-router-dom';
import { createGameBridge } from 'spectacle-ui-game-bridge';
import { GameBridgeContext } from 'spectacle-ui-game-bridge-react';
import { PreloginContextProvider } from './context/PreloginContext';
import './polyfills';
import './sass/app.sass';

(window as any).gameBridge = createGameBridge(true);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const router = createHashRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <Error />,
  },
  {
    path: '/status',
    element: <Status />,
    errorElement: <Error />,
  },
  {
    path: '/acceptance',
    element: <Acceptance />,
    errorElement: <Error />,
  },
  {
    path: '/acceptance-ko',
    element: <AcceptanceKO />,
    errorElement: <Error />,
  },
  {
    path: '/age-gate',
    element: <AgeGate />,
    errorElement: <Error />,
  },
  {
    path: '/loading',
    element: <Loading />,
    errorElement: <Error />,
  },
  {
    path: '/status-test',
    element: <StatusTest />,
    errorElement: <Error />,
  },
  {
    path: '/terms',
    element: <Terms />,
    errorElement: <Error />,
  },
  {
    path: '/login',
    element: <Login />,
    errorElement: <Error />,
  },
  {
    path: '/code-of-conduct',
    element: <CodeOfConduct />,
    errorElement: <Error />,
  },
  {
    path: '/video/:vid',
    element: <Video />,
    errorElement: <Error />,
  },
  {
    path: '/cdni',
    element: <Cdni />,
    errorElement: <Error />,
  },
  {
    path: '/splash',
    element: <Splash />,
    errorElement: <Error />,
  },
  {
    path: '/upsell',
    element: <Upsell />,
    errorElement: <Error />,
  },
  {
    path: '/post-login',
    element: <PostLogin />,
    errorElement: <Error />,
  },
  {
    path: '/gated',
    element: <Gated />,
    errorElement: <Error />,
  },
]);

root.render(
  <React.StrictMode>
    <GameBridgeContext.Provider value={(window as any).gameBridge}>
      <PreloginContextProvider>
        <RouterProvider router={router} />
      </PreloginContextProvider>
    </GameBridgeContext.Provider>
  </React.StrictMode>
);
